import { Reveal, RevealStagger, revealItem } from "@/components/Reveal";
import { motion } from "framer-motion";
import { HIGHLIGHTS } from "@/constants/content";

export const Highlights = () => (
  <section id="highlights" className="cp-section cp-section--navy" data-testid="highlights-section">
    <div className="cp-container">
      <Reveal className="cp-section-head">
        <span className="cp-eyebrow gold">Project Highlights</span>
        <h2 className="cp-h2 light">The Central Plaza Manifesto</h2>
      </Reveal>

      <RevealStagger className="cp-manifesto" stagger={0.08}>
        {HIGHLIGHTS.map((h) => (
          <motion.div
            key={h.num}
            variants={revealItem}
            className="cp-manifesto-row"
            data-testid={`highlight-item-${h.num}`}
          >
            <span className="cp-manifesto-num">{h.num}</span>
            <div className="cp-manifesto-body">
              <h3>{h.title}</h3>
              <p>{h.desc}</p>
            </div>
          </motion.div>
        ))}
      </RevealStagger>
    </div>
  </section>
);
